import { createSlice } from '@reduxjs/toolkit'
import IOpeningHours from 'models/IOpeningHours'

export interface ActionMenuState {
  isLoading: boolean
  openingHours: IOpeningHours[] | null
  getOpeningHoursResponseMessage: string | null
  sendFeedbackResponseMessage: string | null
  isGetOpeningHoursSuccess: boolean | null
  isSendFeedbackSuccess: boolean | null
}

const initialState: ActionMenuState = {
  isLoading: false,
  openingHours: null,
  getOpeningHoursResponseMessage: null,
  sendFeedbackResponseMessage: null,
  isGetOpeningHoursSuccess: null,
  isSendFeedbackSuccess: null,
}

const actionMenuSlice = createSlice({
  name: 'actionMenu',
  initialState,
  reducers: {
    apiRequest: (state) => {
      state.isLoading = true
      state.isGetOpeningHoursSuccess = null
      state.isSendFeedbackSuccess = null
      state.sendFeedbackResponseMessage = null
    },
    apiFailure: (state) => {
      state.isLoading = false
      state.isGetOpeningHoursSuccess = null
      state.isSendFeedbackSuccess = null
      state.sendFeedbackResponseMessage = null
    },
    getOpeningHours(state, action) {
      state.isLoading = false
      state.isGetOpeningHoursSuccess = action.payload.success
      state.getOpeningHoursResponseMessage = action.payload.message
      state.openingHours = action.payload.openingHours
    },
    sendFeedback(state, action) {
      state.isLoading = false
      state.isSendFeedbackSuccess = action.payload.success
      state.sendFeedbackResponseMessage = action.payload.message
    },
  },
})

export const { apiRequest, apiFailure, getOpeningHours, sendFeedback } =
  actionMenuSlice.actions
export default actionMenuSlice.reducer
